<template>
  <header v-if="mode === 'Recipes'">
		<h1>{{ title }}</h1>
		<div v-html="description"></div>
	</header>
	<header v-if="mode === 'Products' && collectionInfo">
		<h1>{{ collectionInfo.name }}</h1>
		<div v-html="collectionInfo.description"></div>
	</header>
	<div class="filters">
		<h2>Filters</h2>
		<button
			type="button"
			:class="[filtersClosed ? 'closed' : 'open', 'filters__toggle']"
			@click="toggleMobileDrawer()"
			aria-controls="filter-container-mobile"
		>
			Filter {{ mode }}
			<svg id="Sub_Recipe_Expand_Icon" data-name="Sub Recipe Expand Icon" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25">
				<g id="Path_219" data-name="Path 219" fill="none">
					<path d="M12.5,0A12.5,12.5,0,1,1,0,12.5,12.5,12.5,0,0,1,12.5,0Z" stroke="none"/>
					<path d="M 12.5 2 C 6.71027946472168 2 2 6.71027946472168 2 12.5 C 2 18.28972053527832 6.71027946472168 23 12.5 23 C 18.28972053527832 23 23 18.28972053527832 23 12.5 C 23 6.71027946472168 18.28972053527832 2 12.5 2 M 12.5 0 C 19.40356063842773 0 25 5.596439361572266 25 12.5 C 25 19.40356063842773 19.40356063842773 25 12.5 25 C 5.596439361572266 25 0 19.40356063842773 0 12.5 C 0 5.596439361572266 5.596439361572266 0 12.5 0 Z" stroke="none" fill="#ac9254"/>
				</g>
				<g id="_" data-name="+" transform="translate(7.07 7.071)">
					<g transform="translate(4.751 0)">
						<rect id="Rectangle_2" data-name="Rectangle 2" width="1.357" height="10.859" fill="#ab9255" stroke="#ac9254" stroke-width="1"/>
					</g>
					<g transform="translate(10.859 4.751) rotate(90)">
						<rect id="Rectangle_3" data-name="Rectangle 3" width="1.357" height="10.859" fill="#ab9255" stroke="#ac9254" stroke-width="1"/>
					</g>
				</g>
			</svg>
		</button>
		<div
			id="filter-container-mobile"
			class="filters__filter-container filters__filter-container--mobile"
			:class="filtersClosed ? 'closed' : 'open'"
			:aria-expanded="filtersClosed ? 'false' : 'true'"
		>
			<div v-for="group in filterGroups">
				<h3>{{ group.name }}</h3>
				<ul>
					<li v-for="filter in group.filters" :key="filter.id">
						{{ filter.group }}
						<input type="checkbox" class="checkbox--larger" :id="filter.id" :value="filter.slug" @change="filterSelect" :checked="isFilterChecked(filter.slug)" />
						<label :for="filter.id"><span v-html="filter.name"></span></label>
					</li>
				</ul>
			</div>
			<button type="button" class="button" @click="toggleMobileDrawer()">Apply Filters</button>
		</div>
		<div
			id="filter-container-desktop"
			class="filters__filter-container filters__filter-container--desktop"
		>
			<div v-for="group in filterGroups">
				<h3>{{ group.name }}</h3>
				<ul>
					<li v-for="filter in group.filters" :key="filter.id">
						{{ filter.group }}
						<input type="checkbox" class="checkbox--larger" :id="filter.id" :value="filter.slug" @change="filterSelect" :checked="isFilterChecked(filter.slug)" />
						<label :for="filter.id"><span v-html="filter.name"></span></label>
					</li>
				</ul>
			</div>
		</div>
	</div>
	<div :class="'items items--' + mode">
		<div class="items__count">
			{{ filteredItems.length }} {{ mode }}
		</div>
		<ul>
			<li v-for="item in filteredItems" :key="item.id" class="item">
				<div class="item__image">
					<img
						v-if="item.image.standard && item.image.standard !== ''"
						:width="(mode === 'Products') ? 200 : 278"
						:height="(mode === 'Products') ? 200 : 230"
						loading="lazy"
						:srcset="item.image.standard + ', ' + item.image.retina + ' 2x'"
						:src="item.image.standard"
						alt=""
					>
					<div class="item__bg">
						<img
							src="https://img.imageboss.me/kings-hawaiian-fs/cover/300x300/format:auto/wp-content/uploads/2024/07/30150856/product-bg-brush.png"
							alt=""
						>
					</div>
					<div class="item__see">
						<a :href="item.permalink">See {{ modeSingular }}</a>
					</div>
				</div>
				<h2>
					<a :href="item.permalink">
						<span v-html="item.title"></span>
					</a>
				</h2>
				<!-- <div>{{ item.id }}</div> -->
				<!-- <ul>
					<li v-for="term in item.terms" :key="term.id">
						<h3>{{ term.name }}</h3>
						<ul>
							<li v-for="filter in term.filters" :key="filter.id">
								{{ filter.name }}
							</li>
						</ul>
					</li>
				</ul> -->
			</li>
		</ul>
	</div>
</template>

<script lang="ts">
declare namespace window {
	export let filterData: any;
}
import { ref, Ref, computed, onMounted } from 'vue';

class FilterGroup {
	name: string;
	slug: string;
	filters: Array<Filter>;
	constructor(name: string, slug: string, filters: Array<Filter>) {
		this.name = name;
		this.slug = slug;
		this.filters = filters;
	};
}

class Filter {
	id: number;
	name: string;
	slug: string;
	count: number;
	selected: boolean;
	itemIds: Array<number> = [];
	constructor(id: number, name: string, slug: string, count: number, selected: boolean, itemIds: Array<number> = []) {
		this.id = id;
		this.name = name;
		this.slug = slug;
		this.count = count;
		this.selected = selected;
		this.itemIds = itemIds;
	};
	increaseCount() {
		this.count++;
	}
	pushItemId(id: number) {
		this.itemIds.push(id);
	}
};

interface Item {
	id: number;
	title: string;
	permalink: string;
	terms: Array<any>;
};

export default {
	setup() {
		const filterData = window.filterData || {};
		const title: string = filterData.title || '';
		const mode: string = filterData.mode || '';
		const description: string = filterData.description || '';
		const items: Array<any> = filterData.items || [];
		const collection: Array<any> = filterData.collection || [];
		const collections: Array<any> = filterData.collections || [];
		const activeFilters: Ref<Array<any>> = ref([]);
		const filtersClosed: Ref<Boolean> = ref(true);

		let filterGroups = computed(() => {
			let groups = new Array<FilterGroup>();
			items.forEach((item: Item) => {
				item.terms.forEach((term) => {
					// console.log('term', term);
					const group = groups.find((g) => g.slug === term.slug);
					if (group) {
						term.filters.forEach((filter: any) => {
							const existingFilter = group.filters.find((f) => f.slug === filter.slug);
							if (existingFilter) {
								existingFilter.increaseCount();
								existingFilter.pushItemId(item.id);
							} else {
								group.filters.push(
									new Filter(filter.id, filter.name, filter.slug, 1, (filter.slug === collection) ? true : false, [item.id])
								);
							}
						});
					} else {
						groups.push(
							new FilterGroup(term.name, term.slug, 
								term.filters.map((filter: any) => {
									return new Filter(filter.id, filter.name, filter.slug, 1, (filter.slug === collection) ? true : false, [item.id]);
								})
							)
						)
					}
				});
			});
			// console.log('groups', groups);
			return groups;
		});

		function filterSelect(event: Event) {
			if (event.target instanceof HTMLInputElement && event.target.type === 'checkbox' && event.target.checked !== undefined) {
				// console.log('filterSelect', event.target.value, event.target.checked);
				const slug = event.target.value;
				const checked = event.target.checked;
				filterGroups.value.forEach((group: FilterGroup) => {
					group.filters.forEach((filter) => {
						if (filter.slug === slug) {
							filter.selected = checked;
						}
					});
				});
				activeFilters.value = filterGroups.value.filter((group: FilterGroup) => {
					return group.filters.some((filter) => filter.selected);
				}).map((group: FilterGroup) => {
					return group.filters.filter((filter) => filter.selected);
				}).flat();
				// console.log('activeFilters', activeFilters.value);
				// add fitler to query params
				const urlParams: URLSearchParams = new URLSearchParams(window?.location.search);
				// console.log('urlParams', urlParams);
				let tax = filterGroups.value.find((group: FilterGroup) => {
					return group.filters.some((filter) => filter.slug === slug);
				}).slug
				// add and remove params with the tax as the key and the selected filters as the values in the query string separated by commas
				if (checked) {
					if (urlParams.has(tax)) {
						let values = urlParams.get(tax)?.split(',');
						values?.push(slug);
						urlParams.set(tax, values.join(','));
					} else {
						urlParams.set(tax, slug);
					}
				} else {
					if (urlParams.has(tax)) {
						let values = urlParams.get(tax)?.split(',');
						values = values?.filter((value) => value !== slug);
						if (values.length > 0) {
							urlParams.set(tax, values.join(','));
						} else {
							urlParams.delete(tax);
						}
					}
				}
				window.history.pushState({}, '', `${window.location.pathname}?${urlParams}`);
			}
		}

		function isFilterChecked(slug: string) {
			return filterGroups && filterGroups.value.some((group: FilterGroup) => {
				return group.filters.some((filter) => {
					return filter.slug === slug && filter.selected;
				});
			});
		}

		let filteredItems = computed(() => {
			// if no filters are selected, return all items
			if (activeFilters.value.length === 0) {
				return items;
			} else {
				// filter items by selected filters
				// within a group filters are OR, between groups filters are AND
				let itemIDAccumulator: Array<any> = [];
				filterGroups.value.forEach((group: FilterGroup) => {
					let groupitemIds: Array<number> = [];
					group.filters.forEach((filter) => {
						if (filter.selected) {
							groupitemIds = groupitemIds.concat(filter.itemIds);
						}
					});
					if (groupitemIds.length > 0) {
						itemIDAccumulator.push(groupitemIds);
					}
				});
				let itemIds = itemIDAccumulator.reduce((acc, val) => {
					return acc.filter((value: any) => val.includes(value));
				});
				return items.filter((item) => {
					return itemIds.includes(item.id);
				});
			}
		});

		function toggleMobileDrawer() {
			filtersClosed.value = !filtersClosed.value;
		}

		function checkQueryParams() {
			const urlParams: URLSearchParams = new URLSearchParams(window?.location.search);
			// console.log('urlParams', urlParams);
			// turn url params into an object
			const params = Array.from(urlParams.entries()).reduce((acc, [key, value]) => {
				acc[key] = value;
				return acc;
			}, {});
			// console.log('params', params);
			// turn on filters based on query params, they will be organized by taxonomy with the terms as values separated by commas
			for (let [key, value] of Object.entries(params)) {
				// console.log('key', key, 'value', value);
				if (filterGroups.value.some((group: FilterGroup) => group.slug === key)) {
					const group = filterGroups.value.find((group: FilterGroup) => group.slug === key);
					const values = value.split(',');
					group.filters.forEach((filter) => {
						if (values.includes(filter.slug)) {
							filter.selected = true;
						}
					});
				}
			};
		}

		let collectionInfo = computed(() => {
			let selectedFilters = null;
			const defaultContent: Object = {
				name: title,
				description: description
			};
			// if there are active filters, lets make a new array of just the selected filters, if there aren't, return the default content
			if (activeFilters.value.length) {
				if (activeFilters.value.length > 0) {
					selectedFilters = activeFilters.value.filter((filter) => filter.selected);
				} else {
					return defaultContent
				}
			} else {
				return defaultContent
			}
			// check if the selected filters match a collection
			let doActiveFiltersContainCollection = activeFilters.value.some((filter) => {
				return collections.map((collection) => collection.slug).includes(filter.slug);
			});
			// if selectedFilters didn't come up with anything, or if the selected filters don't contain a collection, return the default content
			if (typeof selectedFilters === 'undefined' || selectedFilters === null || !doActiveFiltersContainCollection) {
				return defaultContent;
			}
			// get the collection info that matches the selected filters
			let collectionInfo: Array<any> = []
			selectedFilters.map(
				(filter: Filter) => { collectionInfo.push(collections.filter((collection) => collection.slug === filter.slug)) });
				// flatten
				collectionInfo = collectionInfo.flat();
			// if there are multiple collections that match the selected filters, return the default content, if there's just one, return that collectioninfo
			if (collectionInfo.length > 1) {
				return defaultContent;
			} else {
				return collectionInfo[0];
			}
		});

		onMounted(() => {
			// console.log('mounted');
			checkQueryParams();
			activeFilters.value = filterGroups.value.filter((group: FilterGroup) => {
				return group.filters.some((filter) => filter.selected);
			}).map((group: FilterGroup) => {
				return group.filters.filter((filter) => filter.selected);
			}).flat();
		});

		return {
			title,
			mode,
			modeSingular: mode.slice(0, -1),
			description,
			items,
			filteredItems,
			filterGroups,
			filterSelect,
			collection,
			collections,
			toggleMobileDrawer,
			filtersClosed,
			isFilterChecked,
			collectionInfo
		};
	},
};
</script>